import { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Dialog from "../../components/Dialog";
import InputTextStyles from "../../styles/components/InputTextStyles";
import { StyledInfoLabel } from "../../styles/pages/Schedule/ModalViewDetailsStyles";
import UploadFileStyles from "../../styles/pages/UploadFilesStyles";
import ButtonStyles from "../../styles/components/ButtonStyles";
import CheckRadioStyles from "../../styles/components/CheckRadioStyles";

function DialogEditAbono(props: any) {
    const [nomeAbono, setNomeAbono] = useState("");
    const [qtdAfastamento, setQtdAfastamento] = useState<number>();
    const [isAtivo, setIsAtivo] = useState(true);
    const [isAltered, setIsAltered] = useState<boolean>(false);
    const { StyledImportButton, StyledModalTitle, StyledContainerBody } =
        UploadFileStyles;
    const { StyledFormControl, StyledLabel } = InputTextStyles;
    const { DefaultButtonLink } = ButtonStyles;

    useEffect(() => {
        setIsAtivo(props.objectAbono.ativo);
        setNomeAbono(props.objectAbono.motivo);
        setQtdAfastamento(props.objectAbono.quantidadeDias);
    }, [props]);
    return (
        <Dialog openModal={props.createModal} onHide={props.onHide}>
            <StyledModalTitle>Editar Abono</StyledModalTitle>
            <div style={{ height: 20 }} />
            <StyledContainerBody>
                <Container>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <StyledLabel>Status:</StyledLabel>
                        <div style={{ width: 20 }} />
                        <CheckRadioStyles.StyledFormCheck
                            inline
                            label="Ativo"
                            name="group1"
                            type="radio"
                            id="inline-1"
                            checked={isAtivo}
                            disabled
                        />
                        <CheckRadioStyles.StyledFormCheck
                            inline
                            label="Inativo"
                            name="group1"
                            type="radio"
                            id="inline-1"
                            checked={!isAtivo}
                            disabled
                        />
                    </div>
                </Container>
                <div style={{ height: 20 }} />
                <Container>
                    <Col>
                        <StyledInfoLabel>
                            Nome do motivo do abono
                        </StyledInfoLabel>
                    </Col>
                    <div>
                        <StyledFormControl
                            type="text"
                            placeholder="Nome do motivo do abono"
                            onChange={(e: any) => {
                                setNomeAbono(e.target.value as string);
                                setIsAltered(true);
                            }}
                            value={nomeAbono}
                        />
                    </div>
                </Container>
                <div style={{ height: 20 }} />
                <Container>
                    <Col>
                        <StyledInfoLabel>
                            Quantidade de dias de afastamento
                        </StyledInfoLabel>
                    </Col>
                    <div>
                        <StyledFormControl
                            type="number"
                            min="1"
                            max="99"
                            placeholder="Quantidade de dias de afastamento"
                            onChange={(e: any) => {
                                setQtdAfastamento(e.target.value as number);
                                setIsAltered(true);
                            }}
                            value={qtdAfastamento}
                        />
                    </div>
                </Container>
            </StyledContainerBody>
            <Row style={{ justifyContent: "center" }}>
                <StyledImportButton
                    style={{ width: 126, marginTop: 24 }}
                    onClick={() => {
                        props.handleEditCreate(nomeAbono, qtdAfastamento);
                    }}
                    disabled={nomeAbono === "" || !isAltered}
                >
                    Confirmar
                </StyledImportButton>
            </Row>
            <div style={{ height: 15 }} />
            <Row style={{ justifyContent: "center" }}>
                <DefaultButtonLink
                    onClick={() => {
                        props.onHide?.();
                    }}
                >
                    Cancelar
                </DefaultButtonLink>
            </Row>
        </Dialog>
    );
}

export default DialogEditAbono;
